import { ImportResult } from '../../interfaces';

export const importResult: ImportResult = [
    50,
    {
        clientes_creados: { cantidad: 5 },
        sinCliente: { cantidad: 4 },
        sinGeo: { cantidad: 5 },
        duplicados: { cantidad: 5 },
        modificados: { cantidad: 5 },
        sinArticulo: { cantidad: 5 },
        logFile: { link: '/upload_ruteador/log_PedidosPlanificador_10709_2023-01-26_14-47-01.csv' },
        borrados: { cantidad: 5 },
        tiempo_ejecucion: { cantidad: 5 },
        cliente_modificados: { cantidad: 5 },
        cliente_borrados: { cantidad: 5 },
        productos_creados: { cantidad: 5 },
        productos_modificados: { cantidad: 5 },
        pedidos_actualizados: { cantidad: 5 },
        pedidos: { cantidad: 50 },
    },
    {
        'Cliente sin codigo. Lineas:': '4',
        'Cliente sin calle. Lineas:': '8',
    },
];
